import { Link } from 'react-router-dom';
import type { Movie } from '@/types/movie';
import { CATEGORY_LABELS } from '@/types/movie';

export default function HotRanking({ items }: { items: Movie[] }) {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
        <div className="flex items-center gap-2 mb-5">
          <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
            <i className="ri-bar-chart-2-line text-lg text-background-50"></i>
          </span>
          <div>
            <h2 className="font-heading text-xl font-extrabold text-foreground-950">站内热度榜</h2>
            <p className="text-xs text-foreground-600">依据播放热度与用户评分综合排序</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1">
          {items.map((movie, i) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-4 py-3 border-b border-background-200/70 last:border-0"
            >
              <span
                className={`w-7 shrink-0 text-center font-heading text-lg font-extrabold ${
                  i < 3 ? 'text-accent-500' : 'text-foreground-400'
                }`}
              >
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="relative w-11 h-16 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={movie.poster}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title} - 妖精视频热度榜`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                  {movie.title}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-600 truncate">
                  {CATEGORY_LABELS[movie.category]} · {movie.year} · {movie.region}
                </p>
              </div>
              <div className="shrink-0 text-right">
                <div className="font-heading text-sm font-extrabold text-accent-500">{movie.rating.toFixed(1)}</div>
                <div className="text-[11px] text-foreground-500">{(movie.heat / 1000).toFixed(1)}k 热度</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}